module.exports = __webpack_public_path__ + "static/media/empty-concessions.c44bb495.png";